import { useSelector } from 'react-redux';

import { openSyncBranchDialog } from 'src/redux/branches';
import { getConflictStatus } from 'src/redux/pull-request/selectors';
import { getBranchSyncInfo } from 'src/redux/repo-commits/selectors';
import {
  getBranchViewDestinationBranchHash,
  getBranchViewDestinationBranchName,
  getBranchViewDestinationRepoName,
  getBranchViewSourceBranchHash,
  getBranchViewSourceBranchName,
  getBranchViewSourceBranchPermissions,
  UPDATE_SOURCE_BRANCH_HASH,
} from 'src/redux/repository/branch/branch-redux';
import { BranchSyncInfoProps } from 'src/sections/repository/components/commit-list/branch-sync-info';
import {
  getCurrentRepositoryFullSlug,
  getCurrentRepositorySshCloneLink,
} from 'src/selectors/repository-selectors';

export const useBranchSyncInfoDetails = (): BranchSyncInfoProps => {
  const destinationRepositoryFullName =
    useSelector(getBranchViewDestinationRepoName) || '';
  const destinationBranchName =
    useSelector(getBranchViewDestinationBranchName) || '';
  const destinationHash = useSelector(getBranchViewDestinationBranchHash) || '';
  const sourceRepositoryFullName =
    useSelector(getCurrentRepositoryFullSlug) || '';
  const sourceBranchName = useSelector(getBranchViewSourceBranchName) || '';
  const sourceHash = useSelector(getBranchViewSourceBranchHash) || '';
  const branchSyncInfo = useSelector(getBranchSyncInfo);
  const sourceCloneLink = useSelector(getCurrentRepositorySshCloneLink) || '';
  const hasConflicts = useSelector(getConflictStatus);
  const sourceBranchPermissions = useSelector(
    getBranchViewSourceBranchPermissions
  );

  return {
    // Need to flip source and destination information because the destination is the source for syncing
    destinationRepositoryFullName: sourceRepositoryFullName,
    sourceRepositoryFullName: destinationRepositoryFullName,
    branchSyncInfo,
    sourceHash: destinationHash,
    destinationHash: sourceHash,
    destinationBranchName: sourceBranchName,
    sourceBranchName: destinationBranchName,
    hasConflicts,
    sourceCloneLink,
    openSyncDialog: openSyncBranchDialog,
    reloadAction: { type: UPDATE_SOURCE_BRANCH_HASH.REQUEST },
    shouldDisableSync: sourceBranchPermissions?.push !== 'allow',
  };
};
